import { render, staticRenderFns } from "./JobboardIconList.vue?vue&type=template&id=0590dbf8&"
import script from "./JobboardIconList.vue?vue&type=script&lang=js&"
export * from "./JobboardIconList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports